import { fncx } from "@with-cardinal/fncx";

export const ShopPageHero = fncx((elem, listen) => {
	const hero = elem.querySelector("color-select");

	listen(hero, "change", (evt) => {});
});
